import React, { ReactNode } from 'react';

import Typography from 'components/ui/Typography';
import Popover from 'components/ui/Popover';

interface Props {
    children: ReactNode;
    text: string;
}

const Tooltip: React.FC<Props> = ({ text, children }) => {
    return (
        <Popover
            // Todo: Show triangle once offset calculation is fixed
            hideTriangle
            padding="M"
            content={<Typography color="white">{text}</Typography>}
            placement="top"
            color="gray"
        >
            {children}
        </Popover>
    );
};

export default Tooltip;
